// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Pb7","rootMobile":"styles_rootMobile__uQ3d2"};